import React from 'react';
import {motion} from 'framer-motion';
import {useInView} from 'react-intersection-observer';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const {FiShoppingBag,FiCalendar,FiGrid, FiArrowRight}=FiIcons;

const Features=()=> {
  const [ref,inView]=useInView({threshold: 0.1,triggerOnce: true});
  
  const features=[
    {icon: "🎯",title: "Instant Local Discovery",description: "Get up-to-date recommendations in seconds — from queer-run cafés to accessible nightlife events near you."},
    {icon: "🤝",title: "Verified & Inclusive",description: "All listings are curated with care. No rainbow-washing. Just real, safe and welcoming spaces."},
    {icon: "💬",title: "Chat-Based Simplicity",description: "No apps, no downloads. Just message and get what you need — anytime, anywhere."}
  ];

  const serviceFeatures=[
    {
      icon: FiShoppingBag,
      title: "LGBTQIA+ Shopping",
      description: "Discover queer-owned/ally retailers and brands.",
      gradient: "from-pink-500 to-purple-600"
    },
    {
      icon: FiCalendar,
      title: "Events & Experiences",
      description: "Find local and virtual LGBTQIA+ events.",
      gradient: "from-blue-400 to-teal-500"
    },
    {
      icon: FiGrid,
      title: "Business Directory",
      description: "Connect with LGBTQIA+ businesses, creatives and service providers.",
      gradient: "from-orange-500 to-red-600"
    }
  ];

  const containerVariants={
    hidden: {opacity: 0},
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  const itemVariants={
    hidden: {opacity: 0,y: 30},
    visible: {
      opacity: 1,
      y: 0,
      transition: {duration: 0.6,ease: "easeOut"}
    }
  };

  return (
    <section ref={ref} className="py-24 bg-gray-50" aria-labelledby="features-heading">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div variants={containerVariants} initial="hidden" animate={inView ? "visible" : "hidden"} className="text-center mb-16" >
          <motion.h2 variants={itemVariants} id="features-heading" className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6" >
            Why You'll Love It
          </motion.h2>
        </motion.div>
        
        <motion.div variants={containerVariants} initial="hidden" animate={inView ? "visible" : "hidden"} className="grid grid-cols-1 md:grid-cols-3 gap-8" >
          {features.map((feature,index)=> (
            <motion.div key={index} variants={itemVariants} className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 text-center" >
              <div className="text-4xl mb-6">{feature.icon}</div>
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div 
          variants={containerVariants} 
          initial="hidden" 
          animate={inView ? "visible" : "hidden"} 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16"
        >
          {serviceFeatures.map((feature,index)=> (
            <motion.div
              key={index}
              variants={itemVariants}
              className="bg-white p-8 rounded-2xl border border-gray-200 text-center hover:shadow-lg transition-shadow"
            >
              <div className={`w-16 h-16 rounded-full flex items-center justify-center bg-gradient-to-br ${feature.gradient} mx-auto mb-6`}>
                <SafeIcon icon={feature.icon} className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">
                {feature.title}
              </h3>
              <p style={{
      color: 'rgb(75, 85, 99)'
    }} className="text-gray-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y: 30 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-20"
        >
          <a
            href="https://wa.me/message/ST34ZBAH3RQDH1"
            target="_blank"
            rel="noopener noreferrer"
            className="group bg-primary text-white px-8 py-4 rounded-xl font-semibold text-lg hover:bg-primary/90 transition-all duration-300 focus-ring flex items-center space-x-2 shadow-lg hover:shadow-xl mx-auto max-w-xs justify-center"
          >
            <span>Get Early Access Now</span>
          </a>
        </motion.div>
      </div>
    </section>
  );
};
export default Features;